<template>
  <footer id="bottom">
    <div class="container" itemscope itemtype="http://schema.org/LocalBusiness">
      <div class="row align-items-center">

        <div class="col">
          <a class="logo-ecotope" href="http://ecotope.com/" target="_blank">
            <img
              src="/static/build/gfx/svg/logo-ecotope.svg"
              class="logo"
              alt="Ecotope logo"
            >
          </a>
        </div>

        <div class="col-6">
          <div class="row align-items-center justify-content-end">
            <nav class="col-auto footer-nav">
              <ul>
                <li>
                  <a href="https://docs.google.com/forms/d/e/1FAIpQLSc_Q8ib84LHExEhARZ4SKT0n-ky-dZyhZew6cLvHWQSdfMlRw/viewform" target="_blank" rel="noopener">
                    <span>Feedback Form</span>
                  </a>
                </li>
                <li>
                  <a href="/sizer/privacy"><span>Privacy Policy</span></a>
                </li>
              </ul>
            </nav>

            <div class=" col-auto copyright">
              <span class="copyright-text" itemprop="name">
                &copy; 2020–{{currentYear}} Ecotope, Inc
              </span>
            </div>
          </div>

        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Header',
  props: {},
  data: () => ({
    currentYear: new Date().getFullYear()
  }),
}
</script>
